import { useEffect, useState } from 'react';
import { clienteService, prestamoService } from '../../services/api';
import '../../styles/Pagos.css';

const Excusas = () => {
  const [excusas, setExcusas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [prestamos, setPrestamos] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState('');
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);
  const [formData, setFormData] = useState({
    tipo_excusa: 'cliente_ausente',
    motivo: '',
    fecha_excusa: new Date().toISOString().split('T')[0],
    proxima_visita: '',
    observaciones: ''
  });
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });
  const [mostrarFormulario, setMostrarFormulario] = useState(false);

  useEffect(() => {
    cargarClientes();
    cargarExcusas();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.form-group')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll({ per_page: 1000 });
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const cargarExcusas = () => {
    // Cargar excusas del localStorage (temporal hasta tener endpoint backend)
    const excusasGuardadas = localStorage.getItem('excusas');
    if (excusasGuardadas) {
      setExcusas(JSON.parse(excusasGuardadas));
    }
  };

  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    return (
      (cliente.nombres && cliente.nombres.toLowerCase().includes(termino)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(termino)) ||
      (cliente.cedula && cliente.cedula.includes(termino)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(termino)) ||
      cliente.id.toString().includes(termino) ||
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(termino))
    );
  }).slice(0, 10);

  const seleccionarCliente = async (cliente) => {
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setClienteSeleccionado(cliente.id);
    setPrestamos([]);
    setPrestamoSeleccionado('');

    try {
      const response = await prestamoService.getAll({ cliente_id: cliente.id });
      const prestamosActivos = (response.data.prestamos || []).filter(
        p => p.estado === 'activo'
      );
      setPrestamos(prestamosActivos);
    } catch (error) {
      console.error('Error al cargar préstamos:', error);
    }
  };

  const limpiarCliente = () => {
    setClienteObj(null);
    setClienteSeleccionado('');
    setBusquedaCliente('');
    setPrestamos([]);
    setPrestamoSeleccionado('');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!clienteSeleccionado || !prestamoSeleccionado) {
      setMensaje({ tipo: 'error', texto: 'Debe seleccionar un cliente y un préstamo' });
      return;
    }

    const cliente = clientes.find(c => c.id === parseInt(clienteSeleccionado));
    const prestamo = prestamos.find(p => p.id === parseInt(prestamoSeleccionado));

    const nuevaExcusa = {
      id: Date.now(),
      cliente_id: parseInt(clienteSeleccionado),
      cliente_nombre: `${cliente.nombres} ${cliente.apellidos}`,
      cliente_cedula: cliente.cedula,
      prestamo_id: parseInt(prestamoSeleccionado),
      prestamo_monto: prestamo.total,
      ...formData,
      created_at: new Date().toISOString()
    };

    const excusasActualizadas = [...excusas, nuevaExcusa];
    setExcusas(excusasActualizadas);
    localStorage.setItem('excusas', JSON.stringify(excusasActualizadas));

    setMensaje({ tipo: 'success', texto: 'Excusa registrada exitosamente' });

    // Limpiar formulario
    setFormData({
      tipo_excusa: 'cliente_ausente',
      motivo: '',
      fecha_excusa: new Date().toISOString().split('T')[0],
      proxima_visita: '',
      observaciones: ''
    });
    setClienteSeleccionado('');
    setPrestamoSeleccionado('');
    setPrestamos([]);
    setMostrarFormulario(false);
  };

  const eliminarExcusa = (id) => {
    if (!window.confirm('¿Está seguro de eliminar esta excusa?')) return;

    const excusasActualizadas = excusas.filter(e => e.id !== id);
    setExcusas(excusasActualizadas);
    localStorage.setItem('excusas', JSON.stringify(excusasActualizadas));
    setMensaje({ tipo: 'success', texto: 'Excusa eliminada' });
  };

  const tiposExcusa = [
    { value: 'cliente_ausente', label: 'Cliente Ausente' },
    { value: 'negocio_cerrado', label: 'Negocio Cerrado' },
    { value: 'sin_dinero', label: 'Cliente Sin Dinero' },
    { value: 'enfermedad', label: 'Enfermedad' },
    { value: 'viaje', label: 'De Viaje' },
    { value: 'promesa_pago', label: 'Promesa de Pago' },
    { value: 'otro', label: 'Otro' }
  ];

  return (
    <div className="excusas-container">
      <div className="excusas-header">
        <h2>Gestión de Excusas</h2>
        <button
          className="btn-primary"
          onClick={() => setMostrarFormulario(!mostrarFormulario)}
        >
          {mostrarFormulario ? 'Cancelar' : '+ Nueva Excusa'}
        </button>
      </div>

      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      {mostrarFormulario && (
        <form onSubmit={handleSubmit} className="excusa-form">
          <h3>Registrar Nueva Excusa</h3>

          <div className="form-grid">
            <div className="form-group">
              <label>Cliente:</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por nombre, cédula, apodo o ID..."
                  value={busquedaCliente}
                  onChange={(e) => {
                    setBusquedaCliente(e.target.value);
                    setMostrarDropdown(true);
                  }}
                  onFocus={() => setMostrarDropdown(true)}
                />
                {clienteObj && (
                  <button
                    type="button"
                    onClick={limpiarCliente}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'transparent',
                      border: 'none',
                      fontSize: '20px',
                      cursor: 'pointer',
                      color: '#6c757d'
                    }}
                  >
                    ×
                  </button>
                )}

                {mostrarDropdown && busquedaCliente && clientesFiltrados.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    zIndex: 1000,
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  }}>
                    {clientesFiltrados.map((cliente) => (
                      <div
                        key={cliente.id}
                        onClick={() => seleccionarCliente(cliente)}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        {cliente.foto_url ? (
                          <img
                            src={cliente.foto_url}
                            alt={cliente.nombres}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              objectFit: 'cover'
                            }}
                          />
                        ) : (
                          <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold'
                          }}>
                            {cliente.nombres?.charAt(0)}{cliente.apellidos?.charAt(0)}
                          </div>
                        )}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 'bold' }}>
                            {cliente.nombres} {cliente.apellidos}
                            {cliente.apodo && (
                              <span style={{
                                marginLeft: '8px',
                                color: '#007bff',
                                fontStyle: 'italic',
                                fontWeight: 'normal'
                              }}>
                                ({cliente.apodo})
                              </span>
                            )}
                          </div>
                          <div style={{ fontSize: '0.9em', color: '#666' }}>
                            Cédula: {cliente.cedula} • ID: {cliente.id}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {prestamos.length > 0 && (
              <div className="form-group">
                <label>Préstamo:</label>
                <select
                  value={prestamoSeleccionado}
                  onChange={(e) => setPrestamoSeleccionado(e.target.value)}
                  required
                >
                  <option value="">Seleccione un préstamo</option>
                  {prestamos.map(prestamo => (
                    <option key={prestamo.id} value={prestamo.id}>
                      ID: {prestamo.id} - Total: ${prestamo.total.toFixed(2)} - Cuotas: {prestamo.cuotas_pagadas}/{prestamo.cuotas}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>Tipo de Excusa:</label>
              <select
                name="tipo_excusa"
                value={formData.tipo_excusa}
                onChange={handleChange}
                required
              >
                {tiposExcusa.map(tipo => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Fecha de Excusa:</label>
              <input
                type="date"
                name="fecha_excusa"
                value={formData.fecha_excusa}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Próxima Visita:</label>
              <input
                type="date"
                name="proxima_visita"
                value={formData.proxima_visita}
                onChange={handleChange}
              />
            </div>

            <div className="form-group full-width">
              <label>Motivo:</label>
              <textarea
                name="motivo"
                value={formData.motivo}
                onChange={handleChange}
                rows="3"
                required
              />
            </div>

            <div className="form-group full-width">
              <label>Observaciones:</label>
              <textarea
                name="observaciones"
                value={formData.observaciones}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-primary">Registrar Excusa</button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => setMostrarFormulario(false)}
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      <div className="excusas-list">
        <h3>Historial de Excusas ({excusas.length})</h3>

        {excusas.length === 0 ? (
          <div className="sin-datos">
            <p>No hay excusas registradas</p>
            <p>Las excusas permiten llevar un registro de los intentos de cobro sin éxito</p>
          </div>
        ) : (
          <table className="tabla-excusas">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Cliente</th>
                <th>Préstamo</th>
                <th>Tipo</th>
                <th>Motivo</th>
                <th>Próxima Visita</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {excusas.map(excusa => (
                <tr key={excusa.id}>
                  <td>{new Date(excusa.fecha_excusa).toLocaleDateString()}</td>
                  <td>
                    <div><strong>{excusa.cliente_nombre}</strong></div>
                    <div className="text-small">{excusa.cliente_cedula}</div>
                  </td>
                  <td>
                    <div>ID: {excusa.prestamo_id}</div>
                    <div className="text-small">${excusa.prestamo_monto.toFixed(2)}</div>
                  </td>
                  <td>
                    <span className="badge-excusa">
                      {tiposExcusa.find(t => t.value === excusa.tipo_excusa)?.label || excusa.tipo_excusa}
                    </span>
                  </td>
                  <td>{excusa.motivo}</td>
                  <td>
                    {excusa.proxima_visita ? (
                      new Date(excusa.proxima_visita).toLocaleDateString()
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <button
                      className="btn-small btn-danger"
                      onClick={() => eliminarExcusa(excusa.id)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Excusas;
